export default __webpack_public_path__ + "static/media/planet2.8b409ccd.svg";